export const administrationAccountsRoomEquipment = {
    template: require('./administration-accounts-room-equipment.html'),
    controller: 'AdministrationAccountsRoomEquipmentController'
};
